import { Component, Element, h, Host, Prop } from '@stencil/core'
import { css, keyframes } from 'src/lib/emotion'

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
  
`

const animation = css`
  animation: ${spin} 1s linear infinite;
  transform-origin: 0.5em 0.5em;
`

@Component({
  tag: 'ui-spinner',
})
export class Spinner {
  @Element() el: HTMLUiSpinnerElement

  @Prop() strokeWeight = '0.1em'

  componentDidLoad() {
    if (getComputedStyle(this.el).position === 'static') {
      this.el.classList.add('relative')
    }
  }

  render() {
    return (
      <Host class={`${animation} inline-block`} style={{ height: '1em', width: '1em' }}>
        <div class='relative'>
          <div
            class='absolute top-0 left-0 rounded-full'
            style={{
              width: '1em',
              height: '1em',
              opacity: '0.35',
              border: `${this.strokeWeight} solid currentColor`,
            }}
          />
          <div
            class={`absolute top-0 left-0 rounded-full`}
            style={{
              width: '1em',
              height: '1em',
              border: `${this.strokeWeight} solid currentColor`,
              borderLeftColor: 'transparent',
              borderBottomColor: 'transparent',
              borderRightColor: 'transparent',
            }}
          />
        </div>
      </Host>
    )
  }
}
